let StateService = function (Restangular) {
  const Service = Restangular.all('admin/state');

  let count = (query) => {
    return Service.customGET('count', query);
  }

  let save = (state) => {
    if (state.save) {
        return state.save();
    } else {
        return Service.post(state);
    }
  }

  let index = (query) => {
    return Service.getList(query);
  }

  let listStatesWithClient = (query) => {
    return Service.customGET('clients', query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (state) => {
    state.deleted_at = moment();
    return state.save();
  }

  return { index, load, save, show, destroy, listStatesWithClient } ;
};

StateService.$inject = ['Restangular'];

export default StateService;



// WEBPACK FOOTER //
// ./client/app/components/state/state.service.js